import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../../../services/index';
import { message,Tabs ,Modal,Select,Button,DatePicker} from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import 'antd/dist/antd.css';

import { PlusOutlined,MoreOutlined,FieldTimeOutlined,EditOutlined } from '@ant-design/icons';

const { TabPane } = Tabs;
const { Option } = Select;
class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			visible: false,
			tab: 1,
			values: [1],
			category: [],
			package: [],
			package_id: '',
			academic_year: '',
			category_id: '',
			category_count: '',
			amount: '',
			date: [],
			daily_charges: '',
			total_am: 0,
		}
		
		this.onChangebirthday = this.onChangebirthday.bind(this);	
		this.change_year = this.change_year.bind(this);	
		this.change_package = this.change_package.bind(this);	
		this.handleSizeChange = this.handleSizeChange.bind(this);	
		this.change_category = this.change_category.bind(this);	
		this.handleamount = this.handleamount.bind(this);	
		
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],program_id : this.props.match.params.id,school_id : storedArray['data'][0]['school_id'] });
		}
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var app = {school_id : school_id,user_id:user_id,type:this.props.match.params.text}
			getData('fees/category',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							category: result['data'],
						});
					}else{
						this.setState({
							category: [],
						});
					}
				}
			});	
		}	
	}
	
	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		
		const lenght = this.state.values.length;
		
		var amount = [];
			for (var i = 0; i < lenght; i++) {
			 amount[i]= document.getElementById('amount_'+i).value; 
		}
        var daily_charges = [];
			for (var i = 0; i < lenght; i++) {
			 daily_charges[i]= document.getElementById('daily_charges_'+i).value; 
		}
		
		var app = {
			user_id : this.state.user_id,
			school_id : this.state.school_id,
			academic_year : this.state.academic_year,
			package_id : this.state.package_id,
			category_id : this.state.category_id,
			amount : amount,
			date : this.state.date,
			daily_charges : daily_charges,
			type : this.props.match.params.text,
		}
		getData('fees/add_manage_package',app).then((result) => {
			if(result.status==400){
				message.config({ top: 150});
				message.error(result.error_msg,2);
				if(result.error_name=='' && result.error_key!=''){
						document.getElementsByClassName('ant-select-selection')[result.error_key].classList.add("error_focus");
				}
				else{					
					if(result.error_name!=''){
						document.getElementsByName(result.error_name)[0].classList.add("error_focus");
					}					
				}
				this.setState({ loading: false });
			}
			else if(result.status==200){
				message.config({ top: 150});
				message.success('Fees Package added',2);
				this.setState({ loading: false });
				this.setState({comment_text:''});
				window.location.href = '/settings/fees/fees_package/manage/' + this.props.match.params.text;
				//window.location.reload();
			}
			else{
				this.setState({ loading: false });
			}
		});
	  }else{
		message.error('Please Login',2);	
		this.setState({ loading: false });
	  }

  }
	
	
	  
	 
		
	showMenu= (id, e) =>  {
		e.preventDefault();
		if(this.state.showMenu == 1){
			document.getElementById('open_action_' + id).classList.remove('is-active');
			this.setState({
			  showMenu: 0,
			});
		}else{
			document.getElementById('open_action_' + id).classList.add('is-active');
			this.setState({
			  showMenu: 1,
			});
		}
		
		
	}
	
	change_category(event){
		var arr = event.split('_');
		var cat_id = arr[0];
		var cat_count = arr[1];
		var category_arr=this.state.category_id;
		var category_count=this.state.category_count;
		
		if(category_count.indexOf(cat_count) !== -1){
			const index = category_count.indexOf(cat_count);
			if (index > -1) {
			   category_arr.splice(index, 1);
			   category_count.splice(index, 1);
			   this.setState({
				  category_count: category_count,
				  category_id: category_arr
			   });
			   setTimeout(() => {
					this.setState({
					  category_count: [...this.state.category_count, cat_count],
					  category_id: [...this.state.category_id, cat_id]
					});
			   }, 500);
			}
		} else{
			this.setState({
			  category_count: [...this.state.category_count, cat_count],
			  category_id: [...this.state.category_id, cat_id]
			});
		}
     }
	 
	 onChangebirthday(date, dateString){
		this.setState({
		  date: [...this.state.date, dateString]
		})
     }
	 
	
	handleSizeChange = (e) => {		
		this.setState({ [e.target.name]: e.target.value });		
		
	 }; 
	 
	 
	handleamount = (e) => {	
		
		var value = this.state.total_am + e.target.value;
		this.setState({ total_am : value });		
		
	 }; 
	
	change_year(event){
         this.setState({academic_year: event,package_id:''});
		 document.getElementsByClassName('ant-select-selection')[0].classList.remove("error_focus");
		 var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var type = this.props.match.params.text;
			var app = {school_id : school_id,user_id:user_id,academic_year:event,type:type}
			getData('fees/get_fees_package',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							package: result['data'],
						});
					}else{
						this.setState({
							package: [],
						});
					}
				}
			});	
     }
	 
	 change_package(event){
         this.setState({package_id: event});
		 document.getElementsByClassName('ant-select-selection')[1].classList.remove("error_focus");
			
     }
	
	

	
	
	createUI(){
	const lenght = this.state.values.length;
     return this.state.values.map((el, i) => 
		
         <div class={`col m12 mb-10 no-padd ${i}`} key={i}>
					<div class="bb d-inline-block w-100">
						  <div class="col m10 s12">
									<div class="col m3 s12 mb-10 ">
										<label>Category</label>
										<Select name={`category_id_${i}`} id={`category_id_${i}`} onChange={this.change_category} required>
												{this.state.category.map((list) => (
												<Select.Option value={`${list.id}_${i}`}>{list.name}</Select.Option>
												))}
											
										</Select>
									</div>
									<div class="col m3 s12 mb-10 ">
										<label>Amount</label>
										<input type="text" name={`amount_${i}`} id={`amount_${i}`} onChange={this.handleamount}   required/>
									</div>
									<div class="col m3 s12 mb-10 ">
										<label>Due Date</label>
										<DatePicker onChange={this.onChangebirthday} name={`date_${i}`} id={`date_${i}`} required/>
									</div>
									<div class="col m3 s12 mb-10">
										<label>Daily Due Charges</label>
										<input type="text" name={`daily_charges_${i}`} id={`daily_charges_${i}`} onChange={this.handleSizeChange}   required/>
									</div>
								
						  </div>
						  {(() => {
							  
								if (lenght > 1) {
								return (
									
									  <div class="col m2 s12 center mt-20">
											<Button className="cancel-btn snd-btn" onClick={this.removeClick.bind(this, i)}>Remove </Button>
										</div>
									
									)
								}
							})()}
						</div>	
									
         </div>          
     )
  }
  
  addClick(){
    this.setState(prevState => ({ values: [...prevState.values, '']}))
  }
  
  
  removeClick(i){
     let values = [...this.state.values];
     values.splice(i,1);
     this.setState({ values });
  }

	render() {
	
	const { visible, loading } = this.state;	
		return (
			<div class="mobile_view">
			
			
      
      <div id="main">		
         <div class="row">
		 
		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Add Manage Fees Package</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   <li class="breadcrumb-item "><a href="/settings/fees">Fees Setting</a>
                           </li>
						   <li class="breadcrumb-item "><a href="/settings/fees/fees_package/manage">Manage Fees Package</a>
                           </li>
						   <li class="breadcrumb-item active">Add
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
		 
		 
			<div class="col col-md-12  ex-padd">
               <div class="container view-Profile child-profile view-Profile-mobile ">
				<div class="col col-md-12  mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper  section no-padd">
                    <div class="responsive-table iq-card bg-shadow-none">
					
					 
                    <div class="dataTables_wrapper no-footer mh-500  fees iq-card2">
                         <div class="top display-flex flow-root ">
							<div class="actions action-btns display-block align-items-center col col-md-12  right no-padd">
							  
								<div class="col m3 s12 mb-10 pb-20">
										<label>Academic Year</label>
										<Select onChange={this.change_year}>
										 <Select.Option value="2022-2023">2022-2023</Select.Option>	
										 <Select.Option value="2021-2022">2021-2022</Select.Option>	
										 <Select.Option value="2020-2021">2020-2021</Select.Option>
										 <Select.Option value="2019-2020">2019-2020</Select.Option>
										 <Select.Option value="2018-2019">2018-2019</Select.Option>
										</Select>
								</div>
								<div class="col m3 s12 mb-10 pb-20">
										<label>Fees Package</label>
										<Select onChange={this.change_package} value={this.state.package_id}>
											{this.state.package.map((list) => (
												<Select.Option value={list.id}>{list.name}</Select.Option>
											))}	
											
										</Select>
								</div>
								
								
								{this.createUI()} 
						
								<div class="col m12 s12 mb-10 pb-20">
									<Button className="snd-btn" onClick={this.addClick.bind(this)}>Add Category</Button>
								</div>
							  
								 
                            </div>
						</div>
						
						
					<div class="col m12 s12 meal pt-20 mb-20  center">
						 <Button className="cancel-btn large-btn" onClick={this.context.router.history.goBack}>Back</Button>
						 <Button className="snd-btn large-btn" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
					</div>
					
						
				
                    </div>
						
					
						
						
                     </div>
                  </section>
               </div>
               </div>
               <div class="content-overlay"></div>
            </div>	
			
			
			
			
			
			
            <div class="content-overlay"></div>       
      </div>
      </div>
     

			</div>
		) 
	} 
}
export default Index;
